'use client';

import React, { useEffect, useState } from 'react';
import { cn } from '@/utils/cn';
import Button from '../Button';
import Text from '../Text';
import Icon from '../Icon';

function RemoveAddressModal({ onView, onClose }) {
  const [openModal, setOpenModal] = useState(onView);
  // const [isDefaultAddress, setIsDefaultAddress] = useState(false);
  // const [isOpenShippingAddressModal, setIsOpenShippingAddressModal] = useState(false);

  useEffect(() => {
    if (onView) {
      setTimeout(() => {
        setOpenModal(true);
      }, 100);
    } else {
      setOpenModal(false);
    }
  }, [onView]);

  const handleClose = (closeState, data) => {
    // setIsOpenShippingAddressModal(true);
    setOpenModal(closeState);
    setTimeout(() => {
      onClose(false, data);
    }, 200);
  };

  const handleEdit = () => {};

  // const handleCloseShippingAddressModal = state => setIsOpenShippingAddressModal(false);

  return (
    <div
      className={cn(
        'w-full h-full bg-black/30 flex items-center justify-center opacity-0 -z-10 transition-all duration-300 fixed inset-0',
        {
          '!opacity-100 !z-[501]': openModal,
        },
      )}
    >
      <div className="w-full max-w-[800px] mx-8 p-16 lg:p-24 relative rounded-[4px] lg:rounded-[12px] transition-all duration-[400ms]">
        <div className="mb-12">
          <Icon
            type="close"
            color="#fff"
            onClick={() => handleClose(false, false)}
            className="cursor-pointer ml-auto"
          />
        </div>
        <div className="bg-white p-16 rounded-xl shadow-product-slider-shadow">
          <Text
            type="sub_title"
            className="text-fire-chalk text-center text-lg lg:text-2xl font-semibold mb-16"
          >
            Remove Address
          </Text>
          <Text
            type="sub_title"
            className="text-fire-chalk text-center text-lg lg:text-xl font-semibold"
          >
            Do you want to remove the address?
          </Text>

          <div className="flex justify-center gap-4 mt-24">
            <Button
              type="outline"
              className="w-full max-w-[300px] gap-2 !border-pacific-queen line-clamp-1"
              onClick={() => handleClose(false, 'add_address')}
            >
              <Icon type="plus-icon" color="#00685F" />
              <Text
                type="span"
                className="text-tealgreen text-sm lg:text-base font-bold"
              >
                No, Keep It
              </Text>
            </Button>
            <Button
              type="primary"
              className="!bg-tealgreen w-full max-w-[300px] gap-2 !border-pacific-queen line-clamp-1"
              onClick={() => handleClose(false, 'add_address')}
            >
              <Text
                type="span"
                className="text-white text-sm lg:text-base font-bold"
              >
                Remove It
              </Text>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RemoveAddressModal;
